import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { toast } from 'react-toastify';

import { teamCoding } from '../../them';
import TeamCard from './TeamCard';
import Button from '../ui/Button';
import TeamsService from '../../services/TeamsService';
import TeamMemberService from "../../services/TeamMemberService"

let columnsFromBackend = {}

const CreateTeam = () => {


    const loadMembers = async () => {
        try {
            let response = await TeamMemberService.findAll(1, 100);
            if (response && response.status == "200") {
                columnsFromBackend = {
                    "teams": {
                        title: 'Team Members',
                        items: response?.data || [],
                    },
                    "doctors": {
                        title: 'Doctorss',
                        items: [],
                    },
                    "admins": {
                        title: 'Admins',
                        items: [],
                    },
                    "rsos": {
                        title: 'RSOs',
                        items: [],
                    },
                    "nurses": {
                        title: 'Nursesss',
                        items: [],
                    },
                };
                setColumns(columnsFromBackend);


            }
        } catch (error) { console.log(error) }

    }

    useEffect(() => { loadMembers() }, []);

    const [columns, setColumns] = useState([]);
    const [teamMembers, setTeamMembers] = useState([])
    const [name, setName] = useState("");

    const onDragEnd = (result, columns, setColumns) => {
        console.log(result.destination.droppableId)

        if (result.destination.droppableId !== "teams") {
            setTeamMembers((prev) => [...new Set([...prev, result.draggableId])])
            console.log(teamMembers)
        } else {
            setTeamMembers((prev) => prev.filter((item) => item != result.draggableId))

        }
        console.log(teamMembers)

        if (!result.destination) return;


        const { source, destination } = result;



        if (source.droppableId !== destination.droppableId) {
            const sourceColumn = columns[source.droppableId];
            const destColumn = columns[destination.droppableId];
            const sourceItems = [...sourceColumn.items];
            const destItems = [...destColumn.items];
            const [removed] = sourceItems.splice(source.index, 1);
            destItems.splice(destination.index, 0, removed);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
                [destination.droppableId]: {
                    ...destColumn,
                    items: destItems,
                },
            });



        } else {
            const column = columns[source.droppableId];
            const copiedItems = [...column.items];
            const [removed] = copiedItems.splice(source.index, 1);
            copiedItems.splice(destination.index, 0, removed);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...column,
                    items: copiedItems,
                },
            });

        }

        console.log("cols", columns)


    };

    const handleSubmit = async () => {

        if(!name || teamMembers.length ==0 ){
            toast.info("Please add team name and members!");
            return;
        }
        const response = await TeamsService.create({
            name, members: teamMembers
        });

        if (response && !response.data.error) {
            setName("")
            setColumns(columnsFromBackend);
            setTeamMembers([])
            toast.success(response.data.message);
            return
        }
        toast.error("Something went wrong!");
    }
    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-end gap-4">
                <div className="w-full sm:w-72">
                    <label className="form-label">Team Name</label>
                    <input
                        className="form-input"
                        name="name"
                        placeholder="e.g. Team Brown"
                        value={name}
                        onChange={({ target }) => { setName(target.value) }}
                    />
                </div>
                <Button variant="primary" onClick={handleSubmit}>Create Team</Button>
            </div>

            <DragDropContext
                onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
            >
                <div className="flex flex-col md:flex-row gap-4 overflow-x-auto pb-2">
                    {Object.entries(columns).map(([columnId, column], index) => {
                        return (
                            <Droppable key={columnId} droppableId={columnId}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        key={index}
                                        className="bg-neutral-50/80 rounded-lg border border-neutral-100 flex flex-col w-full md:w-1/5 shrink-0"
                                        style={{ height: '75vh' }}
                                    >
                                        <div className="px-3 py-2.5 border-b border-neutral-100 flex items-center gap-2">
                                            <span
                                                className="w-2.5 h-2.5 rounded-full shrink-0"
                                                style={{ backgroundColor: teamCoding(columnId) }}
                                            />
                                            <h4 className="text-xs font-bold text-neutral-500 uppercase tracking-wider truncate">
                                                {column.title}
                                            </h4>
                                            <span className="ml-auto text-[10px] font-semibold text-neutral-400 bg-white border border-neutral-200 rounded-full px-2 py-0.5">
                                                {column.items.length}
                                            </span>
                                        </div>
                                        <div className="flex-1 overflow-y-auto p-2">
                                            {column.items.map((item, index) => (
                                                <TeamCard key={item.id} item={item} index={index} />
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    </div>
                                )}
                            </Droppable>
                        );
                    })}

                </div>
            </DragDropContext>
        </div>
    );
};

export default CreateTeam;
